import React from 'react';

// components
import CommonPaginatedTable from "../Common/CommonPaginatedTable";
import RouteDetail from "./RouteDetail";


class RouteTable extends React.Component {
    render() {
        return(
            <CommonPaginatedTable
                title={this.props.showTitle?'Маршруты':null}
                url={'/route'}
                data={this.props.routes}
                fields={[
                    {
                        title: 'Сущность',
                        name: 'route.entity_human',
                        visible: true,
                    },
                    {
                        title: 'ID Сущности',
                        name: 'route.entity_id',
                        visible: true,
                    },
                    {
                        title: 'Стадия',
                        name: 'stage.title',
                        visible: true,
                        chip: true,
                        color_rule: (value, comparison) => (value),
                        color_value: 'stage.color',
                    },
                    {
                        title: 'Прошло',
                        name: 'delay.0',
                        visible: true,
                        chip: true,
                        color_rule: (value, comparison) => (value>comparison?'danger':'success'),
                        color_value: 'delay.0',
                        color_comparison: 'stage.end_delay',
                        width: '80px',
                    },
                    {
                        title: 'Дедлайн',
                        name: 'stage.end_delay',
                        visible: true,
                        chip: true,
                        color_rule: (value, comparison) => ('primary'),
                        width: '80px',
                    },
                    {
                        title: '',
                        visible: true,
                        component: RouteDetail,
                        componentProps: {
                            overlay: true,
                        },
                        callBack: this.props.callBack,
                        width: '5px',
                    },
                ]
                }
            />
        )
    }
}

export default RouteTable;
